
import { useState } from "react";
import "../App.scss";
import  "../assets/css/libraries.css";
import  "../assets/css/style.css";
import {Helmet} from "react-helmet";
import styled from "styled-components";

function Accordion({ content }) {
  const [open, setOpen] = useState(0);
  return (
    <div>
      
  {/* <!-- ======================
      FAQ
  ========================= --> */}
  <div >
    <div >
      <div className="row">
        
        <div className="col-sm-12 col-md-12 col-lg-12" id="accordion">
          <div className="accordion-item ">
            <div className="accordion__header" data-toggle="collapse" data-target="#collapse3">
              <a className="accordion__title" >Diabetes</a>
            </div>{/* <!-- /.accordion-item-header --> */}
            <div id="collapse3" className="collapse show" data-parent="#accordion">
              <div className="accordion__body" style={{margin:"20px"}}>
              <div style={{fontWeight:"bold", fontSize:"16px"}}><h6 class="post__title">Q: What should I do to control Diabetes? </h6>

</div> 

<div class="post__desc"> 

A: There are 2 types of Diabetes – Type 1 & Type 2. <br/> 

If one suffers from type 1 diabetes, insulin injection is the only therapy as discontinuation of insulin may result in life threatening diabetic emergencies like diabetic ketoacidosis. Till today’s date, there is very little that can be done to restart insulin production from pancreas in type 1 diabetes. Periodic health checkups are also recommended. <br/> 

Those with type 2 diabetes should adopt a low-sugar and low-fat diet; maintain a regular exercise regimen, take timely medicines and schedule timely follow ups with treating doctor. All these are important!<br/> <br/> 

</div> 

<div style={{fontWeight:"bold", fontSize:"16px"}}><h6 class="post__title">



Q: What are some of the complications that can be caused by long-term Diabetes?  </h6>

</div> 

<div> 



A: Diabetes, if unchecked, leads to complications that involve multiple organs. <br/> 
<span style={{marginLeft:"20px"}}>
•	Increased risk of coronary artery disease, heart attacks, strokes & atherosclerosis (narrowing of arteries) <br/> 
</span><span style={{marginLeft:"20px"}}>
•	Eye damage – Retinopathy, cataracts, glaucoma, blindness. <br/> 
</span><span style={{marginLeft:"20px"}}>
•	Kidney damage, which can lead to end-stage kidney disease or renal failure. <br/> 
</span><span style={{marginLeft:"20px"}}>
•	Nerve damage – tingling numbness, pain or burning sensation in limbs <br/> 
</span><span style={{marginLeft:"20px"}}>
•	Erectile Dysfunction <br/> 
</span><span style={{marginLeft:"20px"}}>
•	Diabetic foot disease that may lead to gangrene, resulting <br/> 
</span><span style={{marginLeft:"20px"}}>
•	Increased risk of bacterial and fungal skin infections <br/> 
</span><span style={{marginLeft:"20px"}}>
•	Poor wound healing in amputation. <br/> 
</span>
</div> 
              </div>{/* <!-- /.accordion-item-body --> */}
            </div>
          </div>{/* <!-- /.accordion-item --> */}
          <div className="accordion-item opened">
            <div className="accordion__header" data-toggle="collapse" data-target="#collapse1">
              <a className="accordion__title" >Nutrition & Diet </a>
            </div>{/* <!-- /.accordion-item-header --> */}
            <div id="collapse1" className="collapse" data-parent="#accordion">
              <div className="accordion__body" style={{margin:"20px"}}>
            
              <div style={{fontWeight:"bold", fontSize:"16px"}}><h6 class="post__title">
Q: What should be my ideal diet to stay healthy? </h6>
</div>
<div>
A: Healthy eating means consuming a balanced diet containing the right amounts of foods from all food groups to lead a healthy life. A wide range of nutrients are required to lead a healthy and an active lifestyle. The exact requirements depend on a lot of factors like age, occupation, ailments etc. Getting enough dietary fiber is also an important part of an overall healthy lifestyle. <br/><br/>
</div>
<div style={{fontWeight:"bold", fontSize:"16px"}}><h6 class="post__title">
Q: What are the main sources of fiber? </h6>
</div>
<div>
A: The best sources of fiber are whole grains, fresh fruits and vegetables, legumes, and nuts. Some tips for increasing fiber intake: Eat whole fruits instead of drinking fruit juices. Replace white rice, bread, and pasta with brown rice and whole grain products. <br/><br/>
However, below are the top 10 sources of fiber: <br/>

1. Beans <br/>
2. Broccoli <br/>
3. Berries <br/>
4. Avocados <br/>
5. Popcorn <br/>
6. Whole Grains <br/>
7. Apples <br/>
8. Dried Fruits <br/>
9. Potatoes <br/>
10. Nuts <br/><br/>
</div>
<div style={{fontWeight:"bold", fontSize:"16px"}}><h6 class="post__title">


Q: What is meant by good fiber intake? </h6>
</div>
<div>


A: A minimum intake of 20-35 g of fiber is conducive for long-term good health. WHO recommends a daily intake of 30 g dietary fiber. However, an intake more than 60 g of fiber over a day can reduce the absorption of nutrients and may cause irritation in the bowel and also lead to diarrhea.  <br/><br/>
</div>


              </div>{/* <!-- /.accordion-item-body --> */}
            </div>
          </div>{/* <!-- /.accordion-item --> */}
          <div className="accordion-item">
            <div className="accordion__header" data-toggle="collapse" data-target="#collapse2">
              <a className="accordion__title" >Orthopedics</a>
            </div>{/* <!-- /.accordion-item-header --> */}
            <div id="collapse2" className="collapse" data-parent="#accordion">
              <div className="accordion__body" style={{margin:"20px"}}>
              <div style={{fontWeight:"bold", fontSize:"16px"}}><h6 class="post__title"> Q: What is Osteoarthritis? Is it genetic? </h6>
                </div><div>
A: Primary osteoarthritis is a degenerative disorder due to ageing process. In some cases, arthritis is an auto-immune disorder that develops due to genetic & environmental factors. While it is still unclear what is the exact cause of arthritis, but you have a higher risk of developing arthritis if a close relative has arthritis. <br/><br/>
</div><div style={{fontWeight:"bold", fontSize:"16px"}}><h6 class="post__title"> Q: What are some of the treatment options for Arthritis?</h6>
</div><div>A: As of now, there is no cure for arthritis. However, there are drugs and physical therapy regimen that helps with the pain and reduces the chances of further inflammation.<br/>
According to the severity of your condition, your doctor may prescribe the following:<br/>
<span style={{marginLeft:"20px"}}>1.	Drugs that reduce the pain: Painkillers such as paracetamol. Steroids may be given in injectable or tablet forms for a short period of a time.<br/>
</span><span style={{marginLeft:"20px"}}>2.	DMARD’s (Disease Modifying Anti Rheumatic Drugs) & biological response modifiers are used to suppress the inflammatory agents of arthritis.<br/>
</span><span style={{marginLeft:"20px"}}>3.	Physical therapy is an important aspect in the treatment of arthritis. Hydrotherapy, physiotherapy and occupational therapy helps in regaining your range of motion and doing daily household work with arthritis<br/></span></div>

              </div>{/* <!-- /.accordion-item-body --> */}
            </div>
          </div>{/* <!-- /.accordion-item --> */}
          <div className="accordion-item">
            <div className="accordion__header" data-toggle="collapse" data-target="#collapse4">
              <a className="accordion__title" >VISION & EYE CARE</a>
            </div>{/* <!-- /.accordion-item-header --> */}
            <div id="collapse4" className="collapse" data-parent="#accordion">
              <div className="accordion__body" style={{margin:"20px"}}>
              <div style={{fontWeight:"bold", fontSize:"16px"}}><h6 class="post__title"> 
                Q: How often should I have an eye exam?</h6>
              </div><div>
              A: If you are an adult without risk factors for eye disease, it is recommended that you have an eye examination:<br/>
              <span style={{marginLeft:"20px"}}>• At least once between the ages 20 and 39<br/>
              </span><span style={{marginLeft:"20px"}}>• Every two years between 40 and 50<br/>
              </span><span style={{marginLeft:"20px"}}>• Every year if you are above 50 or older.<br/>
              </span><span style={{marginLeft:"20px"}}>• If you have a family history of glaucoma or history of diabetes, you should be examined every year after 40<br/>
              </span><span style={{marginLeft:"20px"}}>• People with diabetes should get an eye examination done at least once a year </span><br/><br/>
              </div><div style={{fontWeight:"bold", fontSize:"16px"}}><h6 class="post__title"> 
              Q: What is the Laser surgery of Cataract?</h6>
              </div><div>
              A: Laser cataract surgery is called Phacoemulsification Surgery. <br/>
              A 2.2 mm self-sealing incision is made. The cloudy lens is broken into small pieces and sucked out by an ultrasonic high speed vibrating handpiece. After the Cataract material is removed, the back capsule of the lens is left behind on which a clear foldable lens is implanted.<br/>
              Only eye drops are used to make your eyes numb so that there is no pain felt. As there is no injection near the eye involved, patient feels very comfortable and goes back without any pad and bandage.
              </div>
              </div>{/* <!-- /.accordion-item-body --> */}
            </div>
          </div>{/* <!-- /.accordion-item --> */}
          <div className="accordion-item">
            <div className="accordion__header" data-toggle="collapse" data-target="#collapse5">
              <a className="accordion__title" >BEHAVIORAL & MENTAL HEALTH</a>
            </div>{/* <!-- /.accordion-item-header --> */}
            <div id="collapse5" className="collapse" data-parent="#accordion">
              <div className="accordion__body" style={{margin:"20px"}}>
              <div style={{fontWeight:"bold", fontSize:"16px"}}><h6 class="post__title"> Q: What is meant by a Mental illness? </h6></div><div>
                A: Mental illness is a group of biological brain disorders that affect a person’s thinking, mood, emotions, sense of reality, ability to relate and daily functioning. Common disorders are anxiety, depression, schizophrenia, bipolar disorder etc. People of all ages are susceptible but adolescents & young adults are especially vulnerable. <br/><br/>
                </div><div style={{fontWeight:"bold", fontSize:"16px"}}><h6 class="post__title"> 

                Q: How to manage stress? </h6></div><div>
                A: Stress presents differently in different people. While some hide their feelings, other turn to alcohol and drugs. Some withdraw from the world whereas some are angry all the time, lashing out at close ones. The common factor with all these people is that they are under stress and are not able to manage it.<br/><br/>
                Here are some tips to help you manage stress:<br/><br/>
                <span style={{marginLeft:"20px"}}><span style={{fontWeight:"bold"}}>•	Talk it out: </span>Find a mental health professional and start talking about your day to day life. Talking it out helps reduce the mental worry one carries with them. Talking to a professional helps you understand your mechanisms and how to deal better with them.<br/>
                </span><span style={{marginLeft:"20px"}}><span style={{fontWeight:"bold"}}>•	Exercise: </span>Be it the gym or just a run, doing a cardio activity leads to better stress levels<br/>
                </span><span style={{marginLeft:"20px"}}>•	Meditation<br/>
                </span><span style={{marginLeft:"20px"}}>•	Breathing exercises<br/>
                </span><span style={{marginLeft:"20px"}}>•	Choose an activity of your liking<br/>
                </span><span style={{marginLeft:"20px"}}> •	Write a journal</span><br/>
                </div>
              </div>{/* <!-- /.accordion-item-body --> */}
            </div>
          </div>{/* <!-- /.accordion-item --> */}
          
          
          
          
        </div>{/* <!-- /.col-lg-8 --> */}
      </div>{/* <!-- /.row --> */}
    </div>{/* <!-- /.container --> */}
  </div>{/* <!-- /.FAQ --> */}
  <Helmet>
  <script src="../../assets/js/jquery-3.5.1.min.js"></script>
<script src="../../assets/js/plugins.js"></script>
<script src="../../assets/js/main.js"></script>
  <script src=
"https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js" 
  type="text/javascript" />
    <link rel="stylesheet"
  href="https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&family=Roboto:wght@400;700&display=swap"/>
<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.15.3/css/all.css"/>

<link href="../../assets/images/logo/logo-light-small.png" rel="icon"/>
  </Helmet>
    </div>
    // <AccordionWrapper>
    //   {content.map((item, i) => (
    //     <div className="accordion-item">
    //       <button
    //         className={`${open === i ? "header-active" : "header"}`}
    //         onClick={() => setOpen(i)}
    //       >
    //         <h5>{item.heading}</h5>
    //         <img
    //           className={`${open === i ? "icon-active" : "icon"}`}
    //           src="/img/Expand - icon-3.svg"
    //           alt={`${i} accordion item`}
    //         />
    //       </button>
    //       <div className={`${open === i ? "desc-active" : "desc"}`}>
    //         <p>{item.desc}</p>
    //       </div>
    //     </div>
    //   ))}
    // </AccordionWrapper>
  );
}

const AccordionWrapper = styled.div`
  .accordion-item {
    padding: 1rem;
    border-bottom: 1px solid #ccd0d2;
  }
  .header {
    width: 100%;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &-active {
      width: 100%;
      text-align: left;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #eff8f7;
      padding: 1rem;
    }
    .icon {
      transform: rotate(90deg);
      transition: transform 250ms ease-in-out;
      &-active {
        transform: rotate(180deg);
        transition: transform 250ms ease-in-out;
      }
    }
  }
  .desc {
    height: 0;
    transform: scaleY(0);
    &-active {
      padding: 1rem;
      background-color: #eff8f7;
      height: max-content;
      transform: scaleY(1);
      transition: transform 200ms ease-in-out;
    }
  }
`;
export default Accordion;
